// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__OH_mV","label":"CategoryService_label__EfZUk","location":"CategoryService_location__-KZ6X"};